import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import {HeadlineLevel, Margin} from 'features/ui/enums';

import './style.scss';
import {Headline} from 'components/atoms/Text/Headline';
import {Icon} from 'components/atoms/Media/Icon';
import {ButtonLink} from '@atoms/LinksAndButtons/ButtonLink';
import { ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';

interface Props {
    stage?: string;
    headline: string;
}

export const BRFLabel: React.FunctionComponent<Props> = ({stage: _stage, headline}) => {
    return (
        <div className="brf-label">
            <Icon name="trygg-brf" sizeM />
            <Headline 
                level={HeadlineLevel.H3}
                className="brf-label__title" 
                margin={Margin.L} 
            >
                {headline}
            </Headline>
            <ButtonLink
                href={"https://tryggbostadsrattsmarknad.se/"}
                forceExternal
                buttonColor={ButtonColor.DEFAULT} 
                buttonSize={ButtonSize.DEFAULT} 
                buttonType={ButtonType.GHOST} 
            >
                <FormattedMessage id="jm.components.BRFLabel.readMoreAboutBRF" />
            </ButtonLink>
        </div>
    );
};
